import React, { useEffect, useState } from 'react';
import {
  VertButton,
  Spin,
  Col,
  VertAlert,
 
} from '@vertem-core/vertice-ds';
import CouponCard from './CouponCard';
import { Form, Row } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import useScreenSize from 'Hooks/useScreenSize';
import { AnimatePresence } from 'framer-motion';
import usePipeContext from 'Services/Providers/PipeProvider/usePipeContext';
import generateUUID from 'Utils/generateUUID';
import { LoadingOutlined } from '@ant-design/icons';
import { VertInput } from '@vertem-core/vertice-ds';
import ToastAlert from 'components/ToastAlert/ToastAlert';
import ToastErrorAlert from 'components/ToastAlert/ToastErrorAlert';
import CouponErrorSummary from './CouponErrorSummary';


const CartCouponDiscount = ({
  isValidCoupon
}) => {
  const { callApi } = usePipeContext();
  const dispatch = useDispatch();
  const { screenWidth } = useScreenSize();
  const [form] = Form.useForm();
  const {
    coupon,
    errorMessageCoupon,
    isLoadingCoupon: loading,
    isSuccessCoupon,
  } = useSelector((state) => state.Cart);

  const couponAlertIsValid = !coupon || coupon.isValid

  const [couponUpercased, setCouponUpercased] = useState(null);
  const [couponErrorMessages, setCouponErrorMessages] = useState(null);


  const handleDeleteCoupom = async (code) => {
    const data = {
      code: code,
    };

    callApi({
      symbol: 'REMOVE_COUPON_TO_CART',
      alias: generateUUID(),
      payload: data,
    });
  };

  useEffect(() => {
    if (coupon && !coupon?.message && !coupon.isValid) return;

    if (coupon?.isValid) return;

    let errorMessage = coupon?.message;
    
    setCouponErrorMessages(errorMessage);

    return () => {
      setCouponErrorMessages(null);
    };
  }, [coupon?.message, coupon?.isValid]);

  useEffect(() => {
    if (isSuccessCoupon) {
      form.setFieldValue('code', null);
      setCouponUpercased(null);
    }
  }, [isSuccessCoupon]);

  useEffect(() => {
    if (errorMessageCoupon) {
      setCouponErrorMessages(errorMessageCoupon);
    }

    return () => {
      setCouponErrorMessages(null);
    };
  }, [errorMessageCoupon]);

  useEffect(() => {
    return () => {
      dispatch({ type: 'RESET_ERROR_MESSAGE_COUPON' });
    };
  }, []);

  const handleApplyCoupom = async (values) => {
    

    const data = {
      code: values?.code?.toUpperCase() || '',
    };

    dispatch({ type: 'RESET_ERROR_MESSAGE_COUPON' });

    callApi({
      symbol: 'ADD_COUPON_TO_CART',
      alias: generateUUID(),
      payload: data,
    });
  };

  const handleInputChange = (e) => {
    const value = e.target.value.toUpperCase();
    setCouponUpercased(value);
  };
  


  return (
    <Row className="cart-summary-coupom" gutter={[16, 0]}>
      <Form
        layout="vertical"
        onFinish={handleApplyCoupom}
        form={form}
        className="cart-summary-form"
        autoComplete='off'
      >
        <Form.Item
          name="code"
          noStyle
          className="cart-summary-form-item"
          
        >
          <div className="cart-summary-coupon-input">
            <VertInput
              name="code"
              label="CUPOM"
              style={{ flex: 1 }}
              value={couponUpercased}
              onChange={handleInputChange}
              regex={/^[a-zA-Z0-9]*$/}
            />

            <VertButton
              className="vert-coupon-button"
              htmlType="submit"
              type="highlight"
              loading={loading}
              disabled={loading || !isValidCoupon}
            >
              Aplicar
            </VertButton>
          </div>
          


        </Form.Item>
        {couponErrorMessages  && (
        <CouponErrorSummary error={couponErrorMessages}   type={couponAlertIsValid ? 'warning' : 'error'}/>
        )}
      </Form>

      {coupon?.codes.length > 0 && (
        <Spin
        wrapperClassName="cart-loading-wrapper"
          indicator={<LoadingOutlined spin className="cart-loading-spin" />}
          size="small"
          spinning={loading}
        >
          <Row
            verticalSpacing="small"
            style={{
              flexDirection: screenWidth > 576 ? 'column' : '',
              flexWrap: screenWidth > 576 ? 'nowrap' : 'wrap',
            }}
          >
            <Col md={24} sm={24} xs={24} verticalSpacing="small"
            
              className="cart-summary-coupon-list"
            >
              <AnimatePresence
                
              >
                {coupon.codes.map((code, index) => (
                  <CouponCard
                    key={`${code}-${index}`}
                    onClose={() => handleDeleteCoupom(code, false)}
                    name={code}
                  />
                ))}
              </AnimatePresence>
            </Col>
          </Row>
        </Spin>
      )}
    </Row>
  );
};

export default CartCouponDiscount;
